import { render, staticRenderFns } from "./NovelSortDialog.vue?vue&type=template&id=37ca73f3&scoped=true"
import script from "./NovelSortDialog.vue?vue&type=script&lang=ts"
export * from "./NovelSortDialog.vue?vue&type=script&lang=ts"
import style0 from "./NovelSortDialog.vue?vue&type=style&index=0&id=37ca73f3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ca73f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37ca73f3')) {
      api.createRecord('37ca73f3', component.options)
    } else {
      api.reload('37ca73f3', component.options)
    }
    module.hot.accept("./NovelSortDialog.vue?vue&type=template&id=37ca73f3&scoped=true", function () {
      api.rerender('37ca73f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/NovelSortDialog.vue"
export default component.exports